global.FR = global.FR || {};
import commons from '../../commons/js/core-commons';

global.FR.commons = commons;
